import React from 'react'
import { connect } from 'react-redux'
import { Button, Tooltip } from '@material-ui/core'
import {
  CheckCircle,
  CheckCircleOutline,
  Favorite,
  FavoriteBorder,
  Restore,
  RestoreOutlined,
  NavigateBefore,
  NavigateNext
} from '@material-ui/icons'
import { SortAscending, SortDescending } from '../icons/index.js'
import Toolbar from './Toolbar.js'
import { FAVORITE_COLOR, RECENT_COLOR } from '../styles.js'

const FilterToolbar = ({
  onFilterFavoriteToggle,
  showFavorites,
  onFilterActiveToggle,
  showActive,
  onFilterRecentToggle,
  showRecent,

  onSortChange,
  order,

  pageCount,
  currentPage,
  itemCount = 0,
  onPageChange,
  limit,
  menuAnchorEl,
  onMenuClose,

  // From redux
  strings,
  sharePointSaveEnabled
}) => {
  const renderRecentButton = () => {
    if (sharePointSaveEnabled) {
      return (
        <Tooltip title={strings.show_recent} arrow>
          <span>
            <Button
              onClick={onFilterRecentToggle}
              style={recentButtonStyle(showRecent)}
            >
              <span style={recentIconFrameStyle}>
                {showRecent
                  ? <Restore style={recentActiveIconStyle} />
                  : <RestoreOutlined style={recentInactiveIconStyle} />}
              </span>
            </Button>
          </span>
        </Tooltip>
      )
    } else {
      return null
    }
  }

  const setPage = (page) => {
    if (page <= 1) page = 1
    if (page >= pageCount) page = pageCount
    onPageChange(page)
  }

  const sortDisabled = sharePointSaveEnabled && showRecent
  const pageInfo = `${currentPage} / ${pageCount}`

  return (
    <Toolbar menuAnchorEl={menuAnchorEl} onMenuClose={onMenuClose}>
      <div style={toolbarActionsStyle}>
        <div style={leftActionsStyle}>
          <div style={navActionsStyle}>
            <Tooltip title={strings.navigate_back} arrow>
              <span>
                <Button
                  onClick={() => setPage(currentPage - 1)}
                  disabled={pageCount === 0 || currentPage === 1}
                  style={navigateButtonStyle}
                >
                  <NavigateBefore />
                </Button>
              </span>
            </Tooltip>
            <Tooltip title={strings.page_info || 'Page / Total pages'} arrow>
              <span style={pageInfoStyle}>{pageInfo}</span>
            </Tooltip>
            <Tooltip title={strings.navigate_forward} arrow>
              <span>
                <Button
                  onClick={() => setPage(currentPage + 1)}
                  disabled={
                    pageCount === 0 ||
                    currentPage >= pageCount ||
                    itemCount < Number(limit)
                  }
                  style={navigateButtonStyle}
                >
                  <NavigateNext />
                </Button>
              </span>
            </Tooltip>
          </div>
        </div>
        <div style={rightActionsStyle}>
          <Tooltip title={strings.change_sort} arrow>
            <span>
              <Button
                disabled={sortDisabled}
                onClick={onSortChange}
                style={sortButtonStyle(sortDisabled)}
              >
                {order === 'asc' ? <SortAscending /> : <SortDescending />}
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={strings.show_favorites} arrow>
            <span>
              <Button
                onClick={onFilterFavoriteToggle}
                style={favoriteButtonStyle}
              >
                {showFavorites ? <Favorite /> : <FavoriteBorder />}
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={strings.show_active || 'Active only'} arrow>
            <span>
              <Button
                onClick={onFilterActiveToggle}
                style={activeButtonStyle(showActive)}
              >
                <span style={activeIconFrameStyle}>
                  {showActive
                    ? <CheckCircle style={activeFilledIconStyle} />
                    : <CheckCircleOutline style={activeOutlineIconStyle} />}
                </span>
              </Button>
            </span>
          </Tooltip>
          {renderRecentButton()}
        </div>
      </div>
    </Toolbar>
  )
}

const buttonPadding = 1
const toolbarActionsStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%'
}
const leftActionsStyle = { display: 'flex', alignItems: 'center' }
const navActionsStyle = { display: 'flex', alignItems: 'center', position: 'relative', top: -2 }
const rightActionsStyle = { display: 'flex', alignItems: 'center', marginLeft: 'auto' }
const navigateButtonStyle = {
  minWidth: 24,
  height: '100%',
  paddingLeft: buttonPadding,
  paddingRight: buttonPadding
}

const pageInfoStyle = {
  minWidth: 42,
  lineHeight: '40px',
  textAlign: 'center',
  color: '#4b4b4b',
  fontSize: 15
}

const favoriteButtonStyle = {
  color: FAVORITE_COLOR,
  minWidth: 24,
  height: '100%',
  paddingLeft: buttonPadding,
  paddingRight: buttonPadding
}

const sortButtonStyle = (disabled) => {
  return {
    color: disabled ? 'grey' : RECENT_COLOR,
    minWidth: 24,
    height: '100%',
    paddingLeft: buttonPadding,
    paddingRight: buttonPadding
  }
}

const recentButtonStyle = (showRecent) => {
  return {
    color: showRecent ? FAVORITE_COLOR : 'grey',
    minWidth: 24,
    height: '100%',
    paddingLeft: buttonPadding,
    paddingRight: buttonPadding
  }
}

const recentActiveIconStyle = {
  color: '#fff',
  background: FAVORITE_COLOR,
  borderRadius: '50%',
  fontSize: 20,
  width: 20,
  height: 20,
  display: 'block'
}

const recentInactiveIconStyle = {
  color: 'grey',
  fontSize: 20,
  width: 20,
  height: 20,
  display: 'block'
}

const recentIconFrameStyle = {
  width: 20,
  height: 20,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const activeButtonStyle = (showActive) => {
  return {
    color: showActive ? '#1b8f5d' : 'grey',
    minWidth: 24,
    height: '100%',
    paddingLeft: buttonPadding,
    paddingRight: buttonPadding
  }
}

const activeIconFrameStyle = {
  width: 20,
  height: 20,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const activeFilledIconStyle = {
  color: '#1b8f5d',
  fontSize: 20,
  width: 20,
  height: 20,
  display: 'block'
}

const activeOutlineIconStyle = {
  color: 'grey',
  fontSize: 20,
  width: 20,
  height: 20,
  display: 'block'
}

const mapStateToProps = (state) => {
  return {
    strings: state.locale.strings,
    sharePointSaveEnabled: state.login.userData.sharePointSaveEnabled
  }
}

export default connect(mapStateToProps)(FilterToolbar)
